import { useQuery } from '@tanstack/react-query';
import { getShopDetails } from '../libs/apiRequests';

export default function useShopJSON() {
  const { data: shop } = useQuery(getShopDetails.QUERY_TAGS, getShopDetails);

  return shop;
}
